import axios from '@/utils/request'

export function queryWaPage(params) {
  return axios({
    url: '/external/getWhatsAccountPage',
    method: 'get',
    params
  })
}

export function queryContactsPage(params) {
  return axios({
    url: '/external/getFriendDetailPage',
    method: 'get',
    params
  })
}

export function queryLogPage(params) {
  return axios({
    url: '/external/getWhatsAccountLogPage',
    method: 'get',
    params
  })
}

export function queryStatistics(params) {
  return axios({
    url: '/external/getWhatsIdFansStatistics',
    method: 'get',
    params
  })
}

export function queryAnalysis(params) {
  return axios({
    url: '/external/repetitionAnalysis',
    method: 'get',
    params
  })
}

export function queryAnalysisStatistics(data) {
  return axios({
    url: '/external/repetitionAnalysisStatistics',
    method: 'post',
    data
  })
}

export function whatsAccountExport(params) {
  return axios({
    url: '/external/exportWhatsAccount',
    method: 'post',
    params,
    responseType: 'blob'
  })
}

export function fansCountDetailExport(params) {
  return axios({
    url: '/external/exportFansCountDetail',
    method: 'post',
    params,
    responseType: 'blob'
  })
}

export function fansContactExport(params) {
  return axios({
    url: '/external/exportTicketDetail',
    method: 'post',
    params,
    responseType: 'blob'
  })
}

export function whatsLogExport(params) {
  return axios({
    url: '/external/whatsAccountLogExport',
    method: 'post',
    params,
    responseType: 'blob'
  })
}

export function queryChannelSharing(params) {
  return axios({
    url: '/external/getChannelSharing',
    method: 'get',
    params
  })
}

export function repetitionExport(params) {
  return axios({
    url: '/external/repetitionAnalysisExport',
    method: 'post',
    params,
    responseType: 'blob'
  })
}

export function queryTodayChannelFansCount(params) {
  return axios({
    url: '/fans/api/statistics/todayChannelFansCountCount',
    method: 'get',
    params
  })
}

export function queryTotalChannelFansCount(params) {
  return axios({
    url: '/fans/api/statistics/totalChannelFansCountCount',
    method: 'get',
    params
  })
}

export function queryTodayChannelFansRepeatCount(params) {
  return axios({
    url: '/fans/api/statistics/todayRepeatChannelFansCountCount',
    method: 'get',
    params
  })
}

export function queryTotalChannelFansRepeatCount(params) {
  return axios({
    url: '/fans/api/statistics/totalRepeatChannelFansCountCount',
    method: 'get',
    params
  })
}

export function queryTodayChannelFansPage(params) {
  return axios({
    url: '/fans/api/statistics/todayChannelFansCountPage',
    method: 'get',
    params
  })
}

export function queryTotalChannelFansPage(params) {
  return axios({
    url: '/fans/api/statistics/totalChannelFansCountPage',
    method: 'get',
    params
  })
}

export function queryTodayChannelFansRepeatPage(params) {
  return axios({
    url: '/fans/api/statistics/todayRepeatChannelFansCountPage',
    method: 'get',
    params
  })
}

export function queryTotalChannelFansRepeatPage(params) {
  return axios({
    url: '/fans/api/statistics/totalRepeatChannelFansCountPage',
    method: 'get',
    params
  })
}

export function exportChannelFans(params) {
  return axios({
    url: '/fans/api/export/fansCountInfoExport',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

export function exportRepeatChannelFans(params) {
  return axios({
    url: '/fans/api/export/repeatFansCountInfoExport',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

export function queryChannelByShareCode(params) {
  return axios({
    url: '/external/selectChannel',
    method: 'get',
    params
  })
}
